<script setup lang="ts">
import type { PlanningStatus } from '../types/models/test.model';

const props = defineProps<{
	title: string;
}>();

const status: PlanningStatus = {
	id: 1,
	label: 'In Progress',
	isActive: true,
};

const mantra = 'Precision today prevents a thousand bugs tomorrow.';
</script>

<template>
	<div class="planning-module-test" style="padding: 20px; border: 2px solid #0e6167; border-radius: 8px; background-color: #f9fdfd">
		<h3 style="margin-top: 0; color: #0e6167">{{ props.title }}</h3>

		<p style="margin: 10px 0">
			Status:
			<v-chip size="small" :color="status.isActive ? 'success' : 'grey'" label>{{ status.label }}</v-chip>
		</p>

		<hr style="border: 0; border-top: 1px solid #eee; margin: 15px 0" />

		<p style="font-style: italic; color: #666; font-family: 'Georgia', serif">"{{ mantra }}"</p>
	</div>
</template>